import { render, staticRenderFns } from "./MypageTopPane.vue?vue&type=template&id=5da222ed&scoped=true"
import script from "./MypageTopPane.vue?vue&type=script&lang=ts"
export * from "./MypageTopPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageTopPane.vue?vue&type=style&index=0&id=5da222ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da222ed",
  null
  
)

export default component.exports